// @flow
import React, { useCallback } from 'react';
import { isObject, values } from 'lodash';

import { mergeClassNames, mergeStringsWithSpaces } from 'utils/functions';
import { FileInputStyle, processFiles } from 'utils/formHelpers';
import { FormGroup } from 'bs/Input';

/*
type Props = {
    className: string,
    errorText: string | Object,
    helpText: string,
    label: string,
    name: string,
    multiple: Bool,
    id: string,
    readonly: Bool,
    disabled: Bool,
    autofocus: Bool,
    accept: string,
};
*/


export const FileInput = ({
    errorText,
    helpText,
    onChange,
    onBlur,
    ...fieldProps
}) => {
    let {
        className,
        label,
        name,
        multiple,
        value,
        required,
    } = fieldProps;

    const errorClass = errorText ? 'is-invalid' : '';
    className = mergeClassNames('bg-white', className, errorClass);
    if (errorText && isObject(errorText)) {
        errorText = mergeStringsWithSpaces(values(errorText));
    }
    const handleChange = useCallback(event => {
        if (!event.target.files) {
            return;
        }
        processFiles(event.target.files).then((filesInfoEvent) => {
            const newValue = filesInfoEvent.map((fileInfo) => fileInfo.dataURL);
            if (multiple) {
                onChange(newValue);
            } else {
                onChange(newValue[0]);
            }
        });
    }, [multiple, onChange]);

    return (
        <FileInputStyle>
            <FormGroup>
                {label && <label htmlFor={`id_${name}`}>{label}</label>}
                <input
                    accept='.txt,.pdf,.jpg,.jpeg,.png'
                    {...fieldProps}
                    required={value ? false : required}
                    type='file'
                    id={`id_${name}`}
                    name={name}
                    className={className}
                    onBlur={onBlur}
                    onChange={handleChange}
                />
                {errorText && (
                    <small className='form-text text-danger'>{errorText}</small>
                )}
                {helpText && <small className='form-text text-muted'>{helpText}</small>}
            </FormGroup>
        </FileInputStyle>
    );
};

export default FileInput;
